import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import router from '../router/index.js'
import { ElMessage } from 'element-plus';
axios.defaults.baseURL = 'https://api.nxqlhhk.top';

const api = {
  get(url, param, headers) {
    return new Promise((resolve, reject) => {
      axios.get(url, {
        params: param, headers: {
          ...headers, // 👈 只拼接你真正需要的 header 字段
        }
      }).then(response => resolve(response.data ? response.data : response)).catch(error => reject(error));
    });
  },

  post(url, data, headers) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, {
        headers: {
          ...headers, // 👈 只拼接你真正需要的 header 字段
        }
      }).then(response => resolve(response.data ? response.data : response)).catch(error => reject(error));
    });
  },

  upload(url, formData, headers) {
    return new Promise((resolve, reject) => {
      if (!headers) {
        headers = {
          'Content-Type': 'multipart/form-data'
        }
      }
      axios.post(url, formData, {
        headers: headers
      }).then(response => resolve(response.data ? response.data : response)).catch(error => reject(error));
    });
  }
};
axios.interceptors.request.use((config) => {
  console.log('configconfig', config);
  dealToken(config);
  checkToken(config);
  if (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data') {
    config.headers['Content-Type'] = 'application/json';
    config.data = JSON.stringify(config.data);
  }
  console.log('request:', config);
  return config;
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
  console.log('response:', res.data);

  const raw = res.data;

  if (raw.code !== 200 || raw.code == '40001' || raw.code == '40000' || raw.code == '40002') {
    topMsg(raw.errorMsg);
    return;
  }

  return res;
}, (error) => {
  console.log('错误的响应', error);
  topMsg(error.message);
  return Promise.reject(error);
});

function topMsg(text) {
  ElMessage({
    showClose: true,
    message: text,
    center: true,
    type: 'error'
  })

}
function dealToken(config) {
  let url = config.url;
  if (url.indexOf("v4") !== -1) {
    // 设置
    var token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdXRoVXNlciI6eyJtZkF1dGhJZCI6ImRhNzYxNWUwNGRkMWQyY2JmZGQzYzRiNjg3ODczOWFiIiwiYXZhdGFyIjoiaHR0cHM6Ly9zdGF0aWMtbGVnYWN5LmRpbmd0YWxrLmNvbS9tZWRpYS9sUURQTTRtVDZkMWtzWG5OQTZ6TkE2eXdSdURlaDZnMU9Pc0dGX1dSMkNVX0FBXzk0MF85NDAuanBnIiwidXNlck5hbWUiOiLmooHlk7IiLCJsb2dpbk5hbWUiOiJ6aGUubGlhbmdAbW9yZWZ1bi5tZSIsInJvbGVzIjpbeyJjb2RlIjoidHJhY2tBZG1pbiIsIm5hbWUiOiLlkI7lj7DnrqHnkIblkZgiLCJyZW1hcmsiOiLlkI7lj7DnrqHnkIblkZgs6K-l6KeS6Imy5Y-v5Lul6K6_6Zeu5Z-L54K55omA5pyJ55qE6LWE5rqQIiwicm9sZUV4dCI6IntcImFjY2Vzc1wiOlwiKlwifSJ9XX19.LqTthnyml45I5zD76Qmtp92k3FtB-bnOlPOSPtNEE20";
    config.headers.Authorization = token;
  }
}

async function isTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    console.log("token", token, 'payload', payload, 'exp', exp);
    if (!exp) return false; // 如果没有过期时间字段，认为不过期
    console.log('Date.now() >= exp * 1000', Date.now() >= exp * 1000, 'exp * 1000', exp * 1000, 'Date.now()', Date.now());
    return Date.now() >= exp * 1000;
  } catch (e) {
    return true;
  }
}

async function checkToken(config) {
  let url = config.url;
  if (url.includes("login")) {
    return true; // 如果是登录请求，直接返回 true
  }
  let token = localStorage.getItem('auth-token');
  if (!token || await isTokenExpired(token)) {
    // 如果没有 token，跳转到登录页面
    localStorage.removeItem('auth-token');
    localStorage.removeItem('auth-user');
    router.push('/login');
    topMsg('请先登录');
    return false;
  }
  return true;
}
/**
 * 执行DataWorks SQL查询
 * @param sql 要执行的SQL语句
 * @returns {Promise<any>}
 */
async function executeDataWorksSql(sql) {
  const response = await axios.post('/dw/admin/api/v1/dataWorks/proxy', {
    sqlType: "tracking",
    isReturnResult: true,
    isStoreResult: false,
    sql: sql
  });
  return response.data;
}

/**
 * 导出DataWorks SQL结果
 * @param sql 要执行的SQL语句
 * @returns {Promise<any>}
 */
async function exportDataWorksSqlResult(sql) {
  const response = await axios.post('/v3/admin/v1/tracking/dataWorks/toExcelBySql', {
    sql: sql
  });
  return response.data;
}

export default {
  ...api,
  executeDataWorksSql,
  exportDataWorksSqlResult
};
